"use client";

import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { updateUserSearches } from "@lib/util/update-user-searches";
import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import { FlightType } from "types/flights/search";
import { useCustomer } from "../shared/customer-context";
import logger from "@lib/util/shared/logger";
const FlightsSearchContext = /*#__PURE__*/createContext(null);
const defaultFlightInfo = {
  id: 1,
  origin_iata: "",
  flight_type_origin: undefined,
  origin: "",
  flight_type_destination: undefined,
  destination_iata: "",
  destination: "",
  departure_date: undefined,
  return_date: undefined
};
export const FlightsSearchProvider = _ref => {
  let {
    children,
    router
  } = _ref;
  const {
    0: searchState,
    1: setSearchState
  } = useState();
  const {
    0: searchId,
    1: setSearchId
  } = useState('0');
  const {
    0: searchQueryId,
    1: setSearchQueryId
  } = useState();
  const {
    0: firstFareOrder,
    1: setFirstFareOrder
  } = useState([]);
  const {
    0: secondFareOrder,
    1: setSecondFareOrder
  } = useState([]);
  const {
    0: externalSearchTrigger,
    1: setExternalSearchTrigger
  } = useState();
  const {
    0: originSelection,
    1: setOriginSelection
  } = useState();
  const {
    0: destinationSelection,
    1: setDestinationSelection
  } = useState();
  const {
    0: currentFlightIndex,
    1: setCurrentFlightIndex
  } = useState(0);
  const {
    0: flightsSlice,
    1: setFlightsSlice
  } = useState([]);
  const {
    0: fareFamilySlice,
    1: setFareFamilySlice
  } = useState([]);
  const {
    getLoggedCustomer
  } = useCustomer();
  const APP = "flights";

  // Ref to track the previous search for comparison
  const previousSearchRef = useRef();

  // Function to check if search is valid and not empty
  const isValidSearch = search => {
    return !!(search && search.flight_type && search.flight_info && search.flight_info.length > 0 && search.flight_info[0].origin_iata && search.flight_info[0].destination_iata && search.flight_info[0].departure_date && search.passengers_details && search.passengers_details.adults > 0);
  };

  // Function to check if two searches are different
  const isSearchDifferent = (currentSearch, previousSearch) => {
    if (!previousSearch) return true;

    // Compare essential search parameters
    const currentKey = JSON.stringify({
      flight_type: currentSearch.flight_type,
      flight_info: currentSearch.flight_info.map(info => ({
        origin_iata: info.origin_iata,
        destination_iata: info.destination_iata,
        departure_date: info.departure_date,
        return_date: info.return_date
      })),
      passengers_details: currentSearch.passengers_details,
      cabin_class: currentSearch.cabin_class
    });
    const previousKey = JSON.stringify({
      flight_type: previousSearch.flight_type,
      flight_info: previousSearch.flight_info.map(info => ({
        origin_iata: info.origin_iata,
        destination_iata: info.destination_iata,
        departure_date: info.departure_date,
        return_date: info.return_date
      })),
      passengers_details: previousSearch.passengers_details,
      cabin_class: previousSearch.cabin_class
    });
    return currentKey !== previousKey;
  };
  useEffect(() => {
    if (searchState && isValidSearch(searchState)) {
      // Only add to history if search is different from previous
      if (isSearchDifferent(searchState, previousSearchRef.current)) {
        var _getLoggedCustomer$id;
        logger.log('📝 Adding new search to history:', {
          origin: searchState.flight_info[0].origin_iata,
          destination: searchState.flight_info[0].destination_iata,
          departure_date: searchState.flight_info[0].departure_date,
          flight_type: searchState.flight_type
        });
        localStorage.setItem("lastSearch", JSON.stringify(searchState));
        localStorage.setItem("current-app", APP);
        updateUserSearches((_getLoggedCustomer$id = getLoggedCustomer().id) !== null && _getLoggedCustomer$id !== void 0 ? _getLoggedCustomer$id : 0, 'flights', searchState);

        // Update the previous search reference
        previousSearchRef.current = searchState;
      } else {
        logger.log('📝 Search is the same as previous, skipping history update');
      }
    } else if (searchState) {
      var _searchState$flight_i, _searchState$flight_i2, _searchState$flight_i3, _searchState$flight_i4, _searchState$passenge;
      logger.log('📝 Search is not valid, skipping history update:', {
        hasFlightType: !!searchState.flight_type,
        hasFlightInfo: !!searchState.flight_info,
        flightInfoLength: (_searchState$flight_i = searchState.flight_info) === null || _searchState$flight_i === void 0 ? void 0 : _searchState$flight_i.length,
        hasOrigin: !!((_searchState$flight_i2 = searchState.flight_info) !== null && _searchState$flight_i2 !== void 0 && (_searchState$flight_i2 = _searchState$flight_i2[0]) !== null && _searchState$flight_i2 !== void 0 && _searchState$flight_i2.origin_iata),
        hasDestination: !!((_searchState$flight_i3 = searchState.flight_info) !== null && _searchState$flight_i3 !== void 0 && (_searchState$flight_i3 = _searchState$flight_i3[0]) !== null && _searchState$flight_i3 !== void 0 && _searchState$flight_i3.destination_iata),
        hasDepartureDate: !!((_searchState$flight_i4 = searchState.flight_info) !== null && _searchState$flight_i4 !== void 0 && (_searchState$flight_i4 = _searchState$flight_i4[0]) !== null && _searchState$flight_i4 !== void 0 && _searchState$flight_i4.departure_date),
        hasPassengers: !!searchState.passengers_details,
        adults: (_searchState$passenge = searchState.passengers_details) === null || _searchState$passenge === void 0 ? void 0 : _searchState$passenge.adults
      });
    }
  }, [searchState, getLoggedCustomer]);
  const resetSearchQueryId = () => {
    setSearchQueryId(undefined);
  };
  const updateFlightInfo = (flightId, updatedInfo) => {
    setSearchState(prevState => {
      if (!prevState) return prevState;
      const flightIndex = prevState.flight_info.findIndex(flight => flight.id === flightId);
      if (flightIndex === -1) return prevState;
      const newFlightInfo = [...prevState.flight_info];

      // Update the current flight
      newFlightInfo[flightIndex] = _objectSpread(_objectSpread({}, newFlightInfo[flightIndex]), updatedInfo);
      return _objectSpread(_objectSpread({}, prevState), {}, {
        flight_info: newFlightInfo
      });
    });
  };
  const addFlightInfo = () => {
    setSearchState(prevState => {
      if (!prevState) return prevState;
      const newFlight = _objectSpread(_objectSpread({}, defaultFlightInfo), {}, {
        id: prevState.flight_info.length + 1
      });
      return _objectSpread(_objectSpread({}, prevState), {}, {
        flight_info: [...prevState.flight_info, newFlight]
      });
    });
  };
  const deleteFlightInfo = index => {
    setSearchState(prevState => {
      if (!prevState) return prevState;
      const newFlightInfo = prevState.flight_info.filter((_, i) => i !== index);
      return _objectSpread(_objectSpread({}, prevState), {}, {
        flight_info: newFlightInfo
      });
    });
  };
  const resetFlightInfo = flightType => {
    setSearchState(prevState => {
      if (!prevState) return prevState;
      let newFlightInfos = [_objectSpread({}, defaultFlightInfo)];
      if (prevState.flight_info.length > 0) {
        newFlightInfos[0] = _objectSpread(_objectSpread({}, prevState.flight_info[0]), {}, {
          return_date: undefined
        });
      }
      if (flightType === FlightType.MULTI_DESTINATION) {
        const firstFlight = newFlightInfos[0];
        newFlightInfos.push(_objectSpread(_objectSpread({}, defaultFlightInfo), {}, {
          id: 2
        }));
      }
      return _objectSpread(_objectSpread({}, prevState), {}, {
        flight_info: newFlightInfos
      });
    });
  };
  const changeFlightOriginToDestination = flightId => {
    setSearchState(prevState => {
      if (!prevState) return prevState;
      const newFlightInfo = prevState.flight_info.map(flight => {
        if (flight.id === flightId) {
          return _objectSpread(_objectSpread({}, flight), {}, {
            origin: flight.destination,
            origin_iata: flight.destination_iata,
            flight_type_origin: flight.flight_type_destination,
            destination: flight.origin,
            destination_iata: flight.origin_iata,
            flight_type_destination: flight.flight_type_origin
          });
        }
        return flight;
      });
      return _objectSpread(_objectSpread({}, prevState), {}, {
        flight_info: newFlightInfo
      });
    });
  };
  const resetCurrentFlightIndex = () => {
    setCurrentFlightIndex(0);
  };
  return __jsx(FlightsSearchContext.Provider, {
    value: {
      search: searchState,
      setSearch: setSearchState,
      searchQueryId,
      setSearchQueryId,
      resetSearchQueryId,
      firstFareOrder,
      secondFareOrder,
      setFirstFareOrder,
      setSecondFareOrder,
      setFlightsSlice,
      setFareFamilySlice,
      flightsSlice,
      fareFamilySlice,
      externalSearchTrigger,
      setExternalSearchTrigger,
      setOriginSelection,
      setDestinationSelection,
      originSelection,
      destinationSelection,
      updateFlightInfo,
      addFlightInfo,
      deleteFlightInfo,
      resetFlightInfo,
      changeFlightOriginToDestination,
      currentFlightIndex,
      setCurrentFlightIndex,
      resetCurrentFlightIndex
    }
  }, children);
};
export const useFlightsSearch = () => {
  const context = useContext(FlightsSearchContext);
  if (context === null) {
    throw new Error("useFlightsSearch must be used within a FlightsSearchProvider");
  }
  return context;
};